/**
 * 前端时间降级工具函数
 *
 * 按优先级取值：settlement → MVT，并标注数据来源。
 * 降级映射：
 *   Block-off:  settlement_atd      → atd
 *   Wheels-off: settlement_atd_icao → atd_icao
 *   Wheels-on:  settlement_ata_icao → ata_icao
 *   Block-in:   settlement_ata      → ata
 *
 * @see docs/fzx_doc/结算/结算设计/飞行记录表导入_功能规格说明书.md
 */

const FIELD_MAP = {
    atd:      { settlement: "settlement_atd",      mvt: "atd" },
    atd_icao: { settlement: "settlement_atd_icao", mvt: "atd_icao" },
    ata_icao: { settlement: "settlement_ata_icao", mvt: "ata_icao" },
    ata:      { settlement: "settlement_ata",      mvt: "ata" },
};

/**
 * 从航班记录中解析降级后的时间值。
 *
 * @param {Object|null|undefined} record  航班记录（API 响应中的一条）
 * @param {"atd"|"atd_icao"|"ata_icao"|"ata"} field  要解析的 OOOI 时间点
 * @returns {{ value: string|null, source: "settlement"|"mvt"|null, mvtValue: string|null }}
 */
export function resolveTime(record, field) {
    const result = { value: null, source: null, mvtValue: null };

    if (!record || !field) {
        return result;
    }

    const mapping = FIELD_MAP[field];
    if (!mapping) {
        return result;
    }

    const rawSettlement = record[mapping.settlement] ?? null;
    const settlementVal = (rawSettlement !== null && rawSettlement !== "") ? rawSettlement : null;
    const rawMvt = record[mapping.mvt] ?? null;
    const mvtVal = (rawMvt !== null && rawMvt !== "") ? rawMvt : null;

    result.mvtValue = mvtVal;

    if (settlementVal != null) {
        result.value = settlementVal;
        result.source = "settlement";
    } else if (mvtVal != null) {
        result.value = mvtVal;
        result.source = "mvt";
    }

    return result;
}

export default resolveTime;
